const addSpaces = (text) => {
  // Decode any URL-encoded characters
  text = decodeURIComponent(text);

  // Add spaces around special characters
  let spacedText = text
    .replace(/([a-zA-Z])([^a-zA-Z0-9\s])/g, "$1 $2")
    .replace(/([^a-zA-Z0-9\s])([a-zA-Z])/g, "$1 $2");

  // Handle camel case
  spacedText = spacedText
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");

  // Remove any extra spaces that might have been added
  spacedText = spacedText.replace(/\s+/g, " ").trim();

  return spacedText;
};

export default addSpaces;
